"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KushkiError = void 0;
/**
 * KushkiError Generic captured error.
 */
class KushkiError extends Error {
    constructor(error, message = null) {
        const prefix = "K";
        const code = `${prefix}${error.code.replace("E", "")}`;
        /* istanbul ignore next: TODO: reporter is failing */ super(code);
        this.code = code;
        this._customMessage = message;
        this._error = error;
        Object.setPrototypeOf(this, KushkiError.prototype);
    }
    getMessage() {
        if (this._customMessage !== null)
            return this._customMessage;
        return this._error.message;
    }
    getStatusCode() {
        return this._error.statusCode;
    }
}
exports.KushkiError = KushkiError;
